import React, { useState, useEffect } from 'react';
import { WidgetProps } from '@rjsf/core';
import { CheckboxSwitch } from '../BaseComponents';

const CustomCheckbox = (props: WidgetProps) => {
    const { schema, value, onChange, useThemeVariable } = props;
    const [checked, setChecked] = useState<boolean>(value || schema.default);

    useEffect(() => {
        if (useThemeVariable) {
            setChecked(useThemeVariable);
        }
    }, [useThemeVariable]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(e.target.checked);
        onChange(e.target.checked);
    };

    return <CheckboxSwitch title={schema?.title || ''} checked={checked} onChange={handleChange} />;
};

export default CustomCheckbox;
